import { styled } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

export const FooterContainer = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "flex-end",

  borderLeft: `1px solid ${colors.gray200}`,
  borderRight: `1px solid ${colors.gray200}`,
  borderBottom: `1px solid ${colors.gray200}`,
  borderRadius: "0 0 8px 8px",
  padding: "16px 24px",
  wdith: "100%",
}));

const useStyles = makeStyles(() =>
  createStyles({
    main: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    btn1: {
      color: "#475467",
      marginRight: "8px",
    },
    btn2: {
      backgroundColor: "#12B76A",
      color: "white",
    },
  })
);

export default useStyles;
